import React from 'react';
import './RoundedBar.scss';

interface RoundedBarProps {
  isDisabled?: boolean;
}

export const RoundedBar = (props: RoundedBarProps) => {
  const { isDisabled = false } = props;
  const className = isDisabled ? 'rounded-bar disabled' : 'rounded-bar';

  return (
    <div {...{ className }}>
    </div>
  );
}
